import React from 'react';
import styles from './Filters.styles.scss';
import { Button } from '../../../../../../components/shared/Button';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import { FormikField } from '../../../../../../components/FormikField';
import {
  InputField,
  SelectField,
  DatePickerInputField,
} from '../../../../../../components/FormikFields';
import parse from 'date-fns/parse';
import { validationSchema } from './Filters.formConfig';
import { convertDataToForm } from './Filters.helpers';
import {
  INVOICE_TYPES,
  INVOICE_STATUS,
  NOTE_TYPES,
} from '../../../../../../config/invoice/options';

const Filters = ({ onSubmitFilters, currentFilters, onResetFormClick }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className={cn('mt-4', styles.container)}>
      <Formik
        validateOnMount
        enableReinitialize
        validationSchema={validationSchema}
        initialValues={convertDataToForm(currentFilters)}
        onSubmit={onSubmitFilters}
      >
        {({ resetForm, values }) => (
          <Form>
            <div className="row">
              <div className="col-lg-3 col-md-5 col-sm-12 d-flex flex-column">
                <FormikField
                  name="search"
                  component={InputField}
                  label={t('common.search')}
                  componentProps={{
                    className: styles.searchInput,
                    placeholder:
                      i18n.language === 'en' ? 'Search...' : '...بحث',
                  }}
                  controlProps={{
                    labelProps: {
                      className: styles.labels,
                    },
                  }}
                />
              </div>
              <div className="col-lg-3 col-md-5 col-sm-12 d-flex flex-column">
                <FormikField
                  name="invoiceType"
                  component={SelectField}
                  componentProps={{
                    className: styles.field,
                    options: INVOICE_TYPES(i18n.language),
                  }}
                  controlProps={{
                    labelProps: {
                      className: styles.labels,
                    },
                  }}
                  label={t('invoice_list.invoice_type_discription')}
                />
              </div>
              <div className="col-md-3 col-sm-12 d-flex ">
                <div className="d-flex flex-column col-6">
                  <FormikField
                    name="issueDateFrom"
                    component={DatePickerInputField}
                    label={t('invoice_list.date_from')}
                    componentProps={{
                      className: cn(styles.datepicker, styles.dateFrom),
                    }}
                    controlProps={{
                      labelProps: {
                        className: styles.labels,
                      },
                    }}
                  />
                </div>
                <div className="d-flex flex-column col-6">
                  <FormikField
                    name="issueDateTo"
                    component={DatePickerInputField}
                    componentProps={{
                      disabledDays: values?.issueDateFrom
                        ? [
                            {
                              before: parse(
                                values?.issueDateFrom,
                                'dd/MM/yyyy',
                                new Date(),
                              ),
                            },
                          ]
                        : [],
                      className: cn(styles.datepicker, styles.dateTo),
                    }}
                    label={t('invoice_list.date_to')}
                    controlProps={{
                      labelProps: {
                        className: styles.labels,
                      },
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-5 col-sm-12 d-flex flex-column">
                <FormikField
                  name="typeOfNote"
                  component={SelectField}
                  componentProps={{
                    className: styles.field,
                    options: NOTE_TYPES(i18n.language),
                  }}
                  label={t('invoice_list.type_of_note')}
                  controlProps={{
                    labelProps: {
                      className: styles.labels,
                    },
                  }}
                />
              </div>
              <div className="col-lg-3 col-md-5 col-sm-12 d-flex flex-column">
                <FormikField
                  name="invoiceStatus"
                  component={SelectField}
                  componentProps={{
                    className: styles.field,
                    options: INVOICE_STATUS(i18n.language),
                  }}
                  label={t('invoice_list.invoice_status')}
                  controlProps={{
                    labelProps: {
                      className: styles.labels,
                    },
                  }}
                />
              </div>
              <div className={cn('col-lg-9 col-sm-12', styles.buttons)}>
                <Button
                  id="sme_filter_btn"
                  type="submit"
                  className={cn('col-2 mx-2')}
                >
                  {t('common.filter')}
                </Button>
                <Button
                  onClick={() => onResetFormClick(resetForm)}
                  className={cn('col-2 mx-2', styles.resetButton)}
                  variant={'outlined'}
                  id="sme_reset_btn"
                >
                  {t('common.reset')}
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default React.memo(Filters);
